module.exports = __webpack_public_path__ + "img/andvantage-two.84119015.png";